import { DashboardStatistics } from '@xver/@types/dashboard';
import httpClient from '@xver/libs/axios';

const ENDPOINTS = {
    GET: '/v1/dashboard',
};

export function getDashboardStatistics(): Promise<DashboardStatistics> {
    return httpClient.get(ENDPOINTS.GET);
}
